/**
 * Storage permissions.
 *
 * @id - Used to identify the rule on permissions and upload.
 * @folder - Folder where the files will be saved
 * @maxSizeInBytes - Max allowed size in bytes
 * @bypassWritingPermissions - Does not validate if the user has permission to write
 * @publicRead - The file can be publicly accessed via the URL without the need for a signed token
 */
export default class Storage {
  static get values() {
    return {
      eLabelPhotos: {
        id: 'eLabelPhotos',
        folder: 'tenant/:tenantId/eLabel/photos',
        maxSizeInBytes: 5 * 1024 * 1024,
      },

      producerLogo: {
        id: 'producerLogo',
        folder: 'tenant/:tenantId/producer/logo',
        maxSizeInBytes: 5 * 1024 * 1024,
      },

      imageImage: {
        id: 'imageImage',
        folder: 'tenant/:tenantId/image/image',
        maxSizeInBytes: 5 * 1024 * 1024,
      },

      imageDefaultsImage: {
        id: 'imageDefaultsImage',
        folder: 'defaults/:imgType/image/image',
        maxSizeInBytes: 5 * 1024 * 1024,
        bypassWritingPermissions: true,
      },
      settingsLogos: {
        id: 'settingsLogos',
        folder: 'tenant/:tenantId/settings/logos',
        maxSizeInBytes: 5 * 1024 * 1024,
      },
      settingsBackgroundImages: {
        id: 'settingsBackgroundImages',
        folder: 'tenant/:tenantId/settings/backgroundImages',
        maxSizeInBytes: 10 * 1024 * 1024,
      },
      userAvatarsProfiles: {
        id: 'userAvatarsProfiles',
        folder: 'user/avatars/profile/:userId',
        maxSizeInBytes: 5 * 1024 * 1024,
        bypassWritingPermissions: true,
      },
      catalogBranding: {
        id: 'catalogBranding',
        folder: 'tenant/:tenantId/catalog/branding',
        maxSizeInBytes: 5 * 1024 * 1024,
      },
      releaseNotificationImages: {
        id: 'releaseNotificationImages',
        folder: 'admin/release-notifications/images',
        maxSizeInBytes: 10 * 1024 * 1024,
        bypassWritingPermissions: true,
      },
    };
  }
}
